import React from "react";

function Playlists() {
  return (
    <div className="text-white justify-center items-center flex flex-col text-3xl md:mt-[8%] sm:mt-[15%]">
      <h1>Playlists</h1>
      <h2 className="text-xl mt-4">Work In Progress...</h2>
    </div>
  );
}

export default Playlists;
